
        var result = require("!!../../../node_modules/html-loader/index.js!./template.html");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    